export enum SuggestionDiscriminator {
  BET_TYPE = "BET_TYPE",
  POOL_TYPE = "POOL_TYPE",
  SELECTION = "SELECTION",
}

export enum Level {
  ERROR = "ERROR",
  WARNING = "WARNING",
}

export enum BetslipDiscriminator {
  POOL = "POOL",
  FIXED_ODDS = "FIXED_ODDS",
}

export enum EventDiscriminator {
  RACE = "RACE",
  MATCH = "MATCH",
}

export enum NamedType {
  HORSE_RACE_COURSE = "HORSE_RACE_COURSE",
  HORSE = "HORSE",
}

export enum BetOption {
  NONE = "NONE",
  EACH_WAY = "EACH_WAY",
}

export enum BetType {
  SINGLE = "SINGLE",
  DOUBLE = "DOUBLE",
  TREBLE = "TREBLE",
  ACCUMULATOR = "ACCUMULATOR",
  TRIXIE = "TRIXIE",
  PATENT = "PATENT",
  YANKEE = "YANKEE",
  LUCKY_15 = "LUCKY_15",
  SUPER_YANKEE = "SUPER_YANKEE",
  LUCKY_31 = "LUCKY_31",
  HEINZ = "HEINZ",
  LUCKY_63 = "LUCKY_63",
  SUPER_HEINZ = "SUPER_HEINZ",
  GOLIATH = "GOLIATH",
  SINGLE_STAKES_ABOUT = "SINGLE_STAKES_ABOUT",
  FLAG = "FLAG",
  UNION_JACK = "UNION_JACK",
  ROUND_ROBIN = "ROUND_ROBIN",
  SINGLES = "SINGLES",
  CROSS_DOUBLES = "CROSS_DOUBLES",
  CROSS_TREBLES = "CROSS_TREBLES",
  CROSS_FOURFOLDS = "CROSS_FOURFOLDS",
  CROSS_FIVEFOLDS = "CROSS_FIVEFOLDS",
  CROSS_SIXFOLDS = "CROSS_SIXFOLDS",
  CROSS_SEVENFOLDS = "CROSS_SEVENFOLDS",
}

export enum PoolType {
  WIN = "WIN",
  PLACE = "PLACE",
  SHOW = "SHOW",
  WIN_PLACE = "WIN_PLACE",
  WIN_SHOW = "WIN_SHOW",
  PLACE_SHOW = "PLACE_SHOW",
  WIN_PLACE_SHOW = "WIN_PLACE_SHOW",
  EXACTA = "EXACTA",
  QUINELLA = "QUINELLA",
  SWINGER = "SWINGER",
  TRIFECTA = "TRIFECTA",
  QUADFECTA = "QUADFECTA",
  PENTAFECTA = "PENTAFECTA",
  DAILY_DOUBLE = "DAILY_DOUBLE",
  PICKPOT_3 = "PICKPOT_3",
  PICKPOT_4 = "PICKPOT_4",
  PICKPOT_5 = "PICKPOT_5",
  PICKPOT_6 = "PICKPOT_6",
  PICKPOT_7 = "PICKPOT_7",
  PICKPOT_8 = "PICKPOT_8",
  PICKPOT_9 = "PICKPOT_9",
  PICKPOT_10 = "PICKPOT_10",
  GRAND_SLAM = "GRAND_SLAM",
  QUADPOT = "QUADPOT",
  JACKPOT = "JACKPOT",
  PLACEPOT = "PLACEPOT",
  SCOOP_6 = "SCOOP_6",
}

export enum PoolOption {
  NONE = "NONE",
  REVERSE = "REVERSE",
  BANKER = "BANKER",
  COMBINATION = "COMBINATION",
}

export enum LoggerLevel {
  LOG = "LOG",
  INFO = "INFO",
  WARN = "WARN",
  ERROR = "ERROR",
  GROUP = "GROUP",
  TIMER = "TIMER",
}

export enum AvailabilityStatus {
  DISABLED = "DISABLED",
  NONE = "NONE",
  PARTIAL = "PARTIAL",
  FULL = "FULL",
}

export enum MicMode {
  TAP = "TAP",
  HOLD = "HOLD",
}

export enum ExpressionStyle {
  DEFAULT = "DEFAULT",
  NAME = "NAME",
  NUMBER = "NUMBER",
}
